<template>
    <div class="collate-title-bar clearfix">
        <span class="collate-title collate-title-small">创建名人百科</span>
        <div class="collate-type">
            <span v-for="(tab, index) in tabArr" v-bind:key="tab" v-bind:class="{'cur': curPediaCreateTabIndex == index}" @click="clickTab(index)">{{tab}}</span>
        </div>
    </div>
</template>

<script>
import { MOMENT_TIME } from '../../modules/momenttime';
import { FAMOUS_DOM } from '../../modules/dom';
export default {
    name: 'FamousCreateTitleBar',
    computed: {
        curPediaCreateTabIndex() {
            return this.$store.state.famouspedia.curPediaCreateTabIndex;
        }
    },
    data() {
        return {
            tabArr: ['四柱', '选择八字', '输入时间']
        }
    },
    methods: {
        clickTab(index) {
            switch(index) {
                case 0:
                    this.$store.state.famouspedia.curPediaCreateTabIndex = index;
                    break;
                case 1:
                    this.$store.dispatch('allrecord/resetRecordData');
                    this.$store.state.chooserecord.chooseFromPage = 'famouspediacreate';
                    this.$store.state.chooserecord.chooseRecordType = 'single';
                    this.$router.replace('/famouspediacreate/chooserecord');
                    FAMOUS_DOM.hideFamousPediaCreatePage();
                    break;
                case 2:
                    // this.$store.state.collate.formData.birthday = '';
                    this.$store.state.famouspedia.curPediaCreateTabIndex = index;
                    break;
                default:
                    break;
            }
        }
    }
}
</script>